/** Shared V2 chrome tokens for Dashboard Drawer — driven by global brand */

import { brand } from "brand/theme";
import { V2 } from "layout/Dashboard/Header/headerV2Tokens";
import { DRAWER_INSET } from "config";

export { V2 };

export const iconFilterMuted = brand.iconFilters.muted;
export const iconFilterAccent = brand.iconFilters.accent;
export const iconFilterInk = brand.iconFilters.ink;
export const iconFilterOnAccent = brand.iconFilters.onAccent;

/** Base paper chrome (shared) — solid fill so shell gradient never bleeds into nav */
export const drawerPaperBaseSx = {
  backgroundColor: V2.surfaceSolid,
  backgroundImage: "none",
  boxShadow: "none",
  fontFamily: V2.fontBody,
  color: V2.ink,
  borderRadius: 0,
  boxSizing: "border-box",
};

/** Mobile / temporary drawer — edge flush */
export const drawerPaperSx = {
  ...drawerPaperBaseSx,
  borderRight: `1px solid ${V2.line}`,
  top: 0,
  left: 0,
  height: "100%",
};

/** Desktop permanent drawer — floating inset inside the page */
export const drawerPaperInsetSx = {
  ...drawerPaperBaseSx,
  border: `1px solid ${V2.line}`,
  top: DRAWER_INSET.top,
  bottom: DRAWER_INSET.bottom,
  left: DRAWER_INSET.left,
  height: `calc(100% - ${DRAWER_INSET.top + DRAWER_INSET.bottom}px)`,
};

export const navItemSx = ({ drawerOpen, level, isSelected }) => ({
  zIndex: 1201,
  pl: drawerOpen ? `${level * 20}px` : 1.5,
  py: !drawerOpen && level === 1 ? 0 : 0.85,
  fontFamily: V2.fontBody,
  ...(drawerOpen &&
    level === 1 && {
      mx: 1,
      my: 0.15,
      borderRadius: brand.radius.md,
      border: `1px solid transparent`,
      bgcolor: isSelected ? V2.accent : "transparent",
      color: isSelected ? brand.colors.onAccent : V2.ink,
      "&:hover": {
        bgcolor: isSelected ? V2.accentHover || brand.colors.accentHover : V2.accentSoft,
        borderColor: isSelected ? "transparent" : brand.colors.accentBorder,
        color: isSelected ? brand.colors.onAccent : V2.ink,
      },
      "&.Mui-selected": {
        bgcolor: V2.accent,
        color: brand.colors.onAccent,
        "&:hover": {
          bgcolor: brand.colors.accentHover,
          color: brand.colors.onAccent,
        },
      },
    }),
  ...(drawerOpen &&
    level !== 1 && {
      borderRadius: brand.radius.sm,
      mx: 1,
      "&:hover": { bgcolor: V2.accentSoft },
      "&.Mui-selected": {
        bgcolor: V2.accent,
        color: brand.colors.onAccent,
        "&:hover": { bgcolor: brand.colors.accentHover },
      },
    }),
  ...(!drawerOpen && {
    px: 2.75,
    justifyContent: "center",
    "&:hover": { bgcolor: "transparent" },
    "&.Mui-selected": {
      bgcolor: "transparent",
      "&:hover": { bgcolor: "transparent" },
    },
  }),
});

export const miniIconSx = ({ isSelected }) => ({
  position: "relative",
  minWidth: 38,
  borderRadius: brand.radius.md,
  width: 42,
  height: 42,
  alignItems: "center",
  justifyContent: "center",
  filter: "none",
  bgcolor: isSelected ? V2.accent : "transparent",
  border: `1px solid ${isSelected ? V2.accent : "transparent"}`,
  transition: "background 0.2s ease, border-color 0.2s ease",
  "& .drawer-v2-mini-icon": {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 0,
    filter: isSelected ? iconFilterOnAccent : iconFilterMuted,
    transition: "filter 0.2s ease",
  },
  "&:hover": {
    bgcolor: isSelected ? V2.accent : V2.accentSoft,
    borderColor: isSelected ? V2.accent : brand.colors.accentBorder,
    "& .drawer-v2-mini-icon": {
      filter: isSelected ? iconFilterOnAccent : iconFilterAccent,
    },
  },
});
